import { render, staticRenderFns } from "./svgSamsungstore.vue?vue&type=template&id=3a011eeb"
import script from "./svgSamsungstore.vue?vue&type=script&lang=js"
export * from "./svgSamsungstore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports